

















import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import EventBus from '../EventBus'

const profile = namespace('profile')

@Component
export default class Notifications extends Vue {
  // eslint-disable-next-line
  @profile.Action('updateUserData') updateUserData: any;

  // eslint-disable-next-line
  @profile.Action('saveToFirestore') saveToFirestore: any;

  async mounted () {
    // save contactlenses to user
    await this.updateUserData({
      contactlensLeft: this.$route.params.contactlensIdLeft,
      contactlensRight: this.$route.params.contactlensIdRight,
      termsAccepted: new Date(),
      allowOffers: true,
      allowPriceNotifications: true
    })
    await this.saveToFirestore()
    EventBus.$emit('message', { level: 'info', duration: 2000, message: 'Erledigt.', subline: 'Daten wurden gespeichert!' })
    this.$gtm.trackEvent({
      event: 'notification',
      noninteraction: false
    })
  }
}
